import React from 'react';
import { View, StyleSheet, ScrollView, TouchableOpacity } from 'react-native';
import Modal from 'react-native-modal';
import { Text } from '_/components';
import themes from '_/constants/themes';

type QRCodeItem = {
  id: string;
  name: string;
  code: string;
};

type Props = {
  visible: boolean;
  onClose: () => void;
  qrcodesOfflines: [];
  onGoToProfile?: () => void;
};

export default function OfflineQRCodesModal({
  visible,
  onClose,
  qrcodesOfflines,
  onGoToProfile,
}: Props) {
  const mockQRCodes: QRCodeItem[] = [];

  return (
    <Modal
      isVisible={visible}
      onBackdropPress={onClose}
      style={styles.modal}
      animationIn="slideInUp"
      animationOut="slideOutDown"
      useNativeDriver
    >
      <View style={styles.container}>
        <View style={styles.handle} />

        <Text fontType="medium" size={18} style={styles.title}>
          Meus QR Codes
        </Text>

        {qrcodesOfflines.length ? (
          <ScrollView showsVerticalScrollIndicator={false}>
            {mockQRCodes.map((item) => (
              <View key={item.id} style={styles.qrItem}>
                <Text fontType="medium">{item.name}</Text>
                <Text size={12} color={themes.colors.graySecondary}>
                  {item.code}
                </Text>
              </View>
            ))}
          </ScrollView>
        ) : (
          <View style={styles.disabledContainer}>
            <Text
              size={16}
              color={themes.colors.graySecondary}
              style={{ textAlign: 'center', lineHeight: 20 }}
            >
              Para visualizar seus QR Codes offline, faça login e ative essa opção em Perfil &gt;
              Configurações.
            </Text>
          </View>
        )}
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  modal: {
    justifyContent: 'flex-end',
    margin: 0,
  },
  container: {
    backgroundColor: themes.colors.white,
    padding: 24,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    maxHeight: '70%',
  },
  handle: {
    width: 40,
    height: 4,
    backgroundColor: '#DADADA',
    borderRadius: 2,
    alignSelf: 'center',
    marginBottom: 16,
  },
  title: {
    marginBottom: 16,
  },
  qrItem: {
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#F0F0F0',
  },
  disabledContainer: {
    paddingVertical: 24,
    gap: 20,
  },
  profileButton: {
    backgroundColor: themes.colors.primary,
    paddingVertical: 14,
    borderRadius: 12,
    alignItems: 'center',
  },
});
